import login from './login/en';

export default {
  ...login,
};
